module.exports = __webpack_public_path__ + "img/bg.70b9af53.jpg";